<template name="NotFound">
  <h1>
    <span class="has-text-danger">{{ $t('not_found.title') }}</span>
    {{ $t('not_found.subtitle') }}
  </h1>
</template>
